import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { getCountryCode } from '@/modules/common/store/selectors';
import { getPartner } from '@/modules/partner/store/selectors';
import { useStorage } from '@/shared/hooks/useStorage';
import { CountryCode } from '@/shared/models/country-code';

import { useDataProtectionModal } from './useDataProtectionModal';

const key = (_strings: TemplateStringsArray, partnerId: string) => `dvlaAccepted:${partnerId}`;

export const useAcceptDvlaDeclaration = () => {
  const partner = useSelector(getPartner);
  const countryCode = useSelector(getCountryCode);

  const [isAgreed, setIsAgreed] = useStorage<'true' | 'false'>(key`${partner.id}`);

  const { open: showDvlaModal } = useDataProtectionModal();

  return useCallback(async () => {
    // Non-UK users are treated as already agreed
    if (countryCode !== CountryCode.GreatBritain) {
      return true;
    }

    // Already agreed before — skip the modal
    if (isAgreed === 'true') {
      return true;
    }

    const result = await showDvlaModal();

    setIsAgreed(result ? 'true' : 'false');

    return result;
  }, [countryCode, isAgreed, setIsAgreed, showDvlaModal]);
};
